import RolesInfoTable from 'modules/Roles/Partials/RolesInfoTable'
import StatusTabs from 'modules/Roles/Partials/StatusTabs'
import AcceptDrawer from 'modules/Roles/Partials/ViewIndividualRole/AcceptOrRejectDrawer/index'
import {
  SectionWrapper,
  TopHeader,
  TopHeading,
  TopRightFlex,
} from 'modules/Roles/Style/style'
import React, { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { permittedEventCruds } from '../../utils/permissionsValidation'

const Roles = ({
  rolesList,
  singleRoleDetails,
  getRolesListData,
  updateRoleData,
  setJobId,
  getJobDetails,
  instituteCampusId,
  corporateAboutUs,
  getCities,
  citiesList,
  corporateDetails,
  updatePageNum,
  pageNum,
  jobSharingEmail,
  permissions,
  getNotificationCatalogues,
  sendNotificationEmail,
  getUserCorpList,
  sendNotificationBulkEmail,
}) => {
  const object = useRef()
  const [loading, setLoading] = useState(false)
  const [selectionType, setSelectionType] = useState('All')
  const [urlQuery, setUrlQuery] = useState('')
  const [currentPage, setCurrentPage] = useState(0)
  const [selectedRole, setSelectedRole] = useState({})

  const [sortQuery, setSortQuery] = useState('')
  const [newAcceptOrRejectDrawer, setNewAcceptOrRejectDrawer] = useState(false)
  const [searchParams] = useSearchParams()
  const [eventId, setEventId] = useState()
  const [roleAccpectTemplate, setRoleAccpectTemplate] = useState(null)
  const [roleRejectTemplate, setRoleRejectTemplate] = useState(null)
  useEffect(() => {
    if (searchParams.get('page')) {
      setCurrentPage(searchParams.get('page'))
    } else {
      setCurrentPage(0)
    }
  }, [])
  useEffect(() => {
    if (sortQuery) {
      getRolesListData(
        setLoading,
        `${urlQuery}&pageLimit=10&pageNo=${currentPage}&${sortQuery}`
      )
    } else {
      getRolesListData(
        setLoading,
        `${urlQuery}&pageLimit=10&pageNo=${currentPage}`
      )
    }
    updatePageNum(currentPage)
    getCities()
  }, [urlQuery, currentPage, sortQuery])

  const changeState = type => {
    setSelectionType(type)
    if (type == 'All') {
      setUrlQuery('')
    } else if (type == 'AcceptedRoles') {
      setUrlQuery('status=1')
    } else {
      setUrlQuery('saved=1')
    }
    setCurrentPage(0)
  }

  const onFilerChange = query => {
    let preFix = ''
    
    // Check if query already contains status=1 or saved=1
    const hasStatus = query.includes('status=1')
    const hasSaved = query.includes('saved=1')
    
    if (selectionType === 'AcceptedRoles') {
      preFix = hasStatus ? query : `status=1&${query}`
    } else if (selectionType === 'Saved') {
      preFix = hasSaved ? query : `saved=1&${query}`
    } else {
      preFix = query
    }

    setUrlQuery(preFix)
  }
  const onSortingChanged = query => {
    setSortQuery(query)
  }
  const onAcceptOrRejectClick = data => {
    setSelectedRole(data)
    setNewAcceptOrRejectDrawer(true)
  }
  const onDrawerClose = flag => {
    setNewAcceptOrRejectDrawer(flag)
    getRolesListData(
      setLoading,
      `${urlQuery}&pageLimit=10&pageNo=${currentPage}`
    )
  }
  const ScrollRef = () => {
    object.current.scrollIntoView({ behavior: 'smooth' })
  }
  const permittedEvents = permittedEventCruds(permissions, 'ROLES')

  const cruds = permittedEvents?.map(permission =>
    permission?.events?.eventName?.toUpperCase()
  )

  const shareJob =
    permittedEvents?.find(
      item => item?.subEvents?.subEventName === 'SHARE JOB DETAILS'
    )?.subEvents || ''

  const onAcceptOrRejectRole =
    permittedEvents?.find(item => item.events?.eventName === 'ACCEPT/REJECT')
      ?.events || ''

  useEffect(() => {
    ;(async () => {
      if (onAcceptOrRejectRole?.id) {
        let responce = await getNotificationCatalogues(onAcceptOrRejectRole?.id)
        const filteredArray = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName === 'Role Accepted' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray?.length > 0) {
          setRoleAccpectTemplate(filteredArray[0].eventNotificationTemplate)
        }

        const filteredArray1 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName === 'Role Rejected' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray1?.length > 0) {
          setRoleRejectTemplate(filteredArray1[0].eventNotificationTemplate)
        }
      }
    })()

    return () => {}
  }, [onAcceptOrRejectRole])

  return (
    <SectionWrapper column>
      <div ref={object}></div>
      <TopHeader row spaceBetween alignCenter>
        <TopHeading flexStart>Roles</TopHeading>
        <TopRightFlex></TopRightFlex>
      </TopHeader>
      <StatusTabs
        selected={selectionType}
        selectedType={type => {
          changeState(type)
        }}
      />

      <RolesInfoTable
        selectionType={selectionType}
        ScrollRef={ScrollRef}
        rolesList={rolesList}
        updateRoleData={updateRoleData}
        setJobId={setJobId}
        setUrl={onFilerChange}
        currentUrl={urlQuery}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        getJobDetails={getJobDetails}
        corporateAboutUs={corporateAboutUs}
        corporateDetails={corporateDetails}
        onAcceptOrRejectClick={onAcceptOrRejectClick}
        onSortValueChanged={onSortingChanged}
        loading={loading}
        citiesList={citiesList}
        getCities={getCities}
        jobSharingEmail={jobSharingEmail}
        cruds={cruds}
        eventId={shareJob?.id}
        onAcceptOrRejectRole={onAcceptOrRejectRole}
        setEventId={setEventId}
        urlQuery={urlQuery}
      />
      {newAcceptOrRejectDrawer && (
        <AcceptDrawer
          newAcceptOrRejectDrawer={newAcceptOrRejectDrawer}
          setnewAcceptOrRejectDrawer={onDrawerClose}
          instituteCampusId={instituteCampusId}
          jobId={selectedRole?.jobRoles?.id}
          roleStatus={selectedRole?.status}
          jobSharingEmail={jobSharingEmail}
          selectedRole={selectedRole}
          eventId={eventId}
          sendNotificationEmail={sendNotificationEmail}
          sendNotificationBulkEmail={sendNotificationBulkEmail}
          roleaccpectTemplate={roleAccpectTemplate}
          rolerejectTemplate={roleRejectTemplate}
          getUserCorpList={getUserCorpList}
        />
      )}
    </SectionWrapper>
  )
}
export default Roles
